// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces   `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  /*apiUrl: 'http://api.pricepilot.loc/app_dev.php',
  docsUrl: 'http://docs.api.pricepilot.loc',
  assetsUrl: 'http://assets.pricepilot.loc',
  authUrl: 'http://auth.pricepilot.loc',
  */

  /*apiUrl: 'https://testing.api.pricepilot.si/app_dev.php',
  docsUrl: 'https://testing.docs.api.pricepilot.si',
  assetsUrl: 'https://testing.assets.api.pricepilot.si',
  authUrl: 'https://testing.auth.pricepilot.si',
  */

  /*apiUrl: 'https://demo.api.pricepilot.si',
  docsUrl: 'https://demo.docs.api.pricepilot.si',
  assetsUrl: 'https://demo.assets.pricepilot.si',
  authUrl: 'https://demo.auth.pricepilot.si',

  siteId: 10,
  siteUrl: 'https://demo.table42.app',
  siteName: 'Table42',
  domain: 'demo.table42.app',
  //domain: 'localhost:8100',
  restaurantFieldId: 6,
  facebookAppId: '467582367951288'*/


  apiUrl: 'https://api.pricepilot.io',
  docsUrl: 'https://docs.api.pricepilot.io',
  assetsUrl: 'https://assets.pricepilot.io',
  authUrl: 'https://auth.pricepilot.io',

  siteId: 197,
  siteUrl: 'https://book.table42.app',
  siteName: 'Table42',
  domain: 'book.table42.app',
  //domain: 'localhost:8100',
  restaurantFieldId: 2,
  facebookAppId: '2081619068666087'
  


  /*siteId: 10,
  //siteUrl: 'https://demo.table42.app',
  siteUrl: 'https://demo.table42.app',
  siteName: 'Dev Table42',
  domain: 'demo.table42.app',
  //domain: 'localhost:8100',
  restaurantFieldId: 2,
  facebookAppId: '535061778202314'
  */
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
